module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("註冊會員身分驗證")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-920e7daa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Active.vue
// module id = 305
// module chunks = 1